import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['Acceso inmediato a los 12 tomos', 'Actividades listas para imprimir o proyectar', 'Planificación anual ya armada', 'Materiales editables', 'Recursos audiovisuales incluidos', 'Acceso a futuras actualizaciones'];
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-94" data-mp="1wcq9w9lhdmfj">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-95" data-mp="1wb5hapiq8dkb">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/15 text-brand-orange" data-id="element-96" data-mp="1reotjwffw17r">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-97" data-mp="25cvg4gexues4" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-98" data-mp="20fmxkepvo8qc">
          ⚡ ¿Qué Obtenés al Instante?
        </h2>
        <div className="space-y-3 text-left" data-id="element-99" data-mp="azvuo6nvmqcx">
          {items.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-100" data-mp="623ruhlp1jty">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-101" data-mp="2rzyp45ngc16m" />
              <span className="font-semibold" data-id="element-102" data-mp="2wzl0sanmt9db">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-purple" data-id="element-103" data-mp="31qt9t5l1uspy">
          Nunca te vas a quedar sin material.
        </p>
      </Reveal>
    </section>;
}